import {
  Box,
  TableBody,
  TableHead,
  TableRow,
  styled,
  TableCell,
  tableCellClasses,
  TextField,
} from "@mui/material";
import { StyledTable, StyledTableContainer } from "../MyPatients/style";

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {},
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#ffcc00",
    color: "black",
    padding: "10px",
    wordBreak: "unset",
    whiteSpace: "wrap",
  },
  [`&.${tableCellClasses.body}`]: {
    padding: "10px",
    wordBreak: "unset",
    whiteSpace: "wrap",
  },
}));

type TreatmentPlanPharmacologicalTableProps = {
  data: any[];
  TreatmenteditMode: boolean;
  TreatmentTextInputs: { [key: string]: any };
  handleTreatmentInputChange: (fieldKey: string, value: string) => void;
};

type TreatmentPlanNonPharmacologicalTableProps = {
  data: any[];
  TreatmenteditMode: boolean;
  TreatmentTextInputs: { [key: string]: string };
  handleTreatmentInputChange: (fieldKey: string, value: string) => void;
};


const TreatmentPlanPharmacologicalTable = ({
  data,
  TreatmenteditMode,
  TreatmentTextInputs,
  handleTreatmentInputChange,
}: TreatmentPlanPharmacologicalTableProps) => {
  return (
    <Box style={{ width: "100%", overflowX: "auto" }}>
      <StyledTableContainer>
        <StyledTable style={{ tableLayout: "auto" }}>
          <TableHead>
            <TableRow key={"tableHead"}>
              <StyledTableCell align="left">ICD Code</StyledTableCell>
              <StyledTableCell align="left">Medication Name</StyledTableCell>
              <StyledTableCell align="left">
                Medication Indication
              </StyledTableCell>
              <StyledTableCell align="left">Pregnancy Alerts</StyledTableCell>
              <StyledTableCell align="left">
                Breastfeeding Alert
              </StyledTableCell>
              <StyledTableCell align="left">Contraindications</StyledTableCell>
              <StyledTableCell align="left">Age Cautionary</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, i) => {
              const fields = [
                { key: "code", label: item.code },
                { key: "pharmacotherapy", label: item.pharmacotherapy },
                { key: "indication", label: item.indication },
                {
                  key: "fda_pregnancy_categories",
                  label: item.fda_pregnancy_categories,
                },
                {
                  key: "breastfeeding_warnings",
                  label: item.breastfeeding_warnings,
                },
                { key: "contraindications", label: item.contraindications },
                { key: "age_warnings", label: item.age_warnings },
              ];

              return (
                <StyledTableRow key={i}>
                  {fields.map((field, idx) => {
                    const inputKey = `${field.key}_${i}`;
                    return (
                      <StyledTableCell align="left" key={idx}>
                        {TreatmenteditMode ? (
                          <TextField
                            fullWidth
                            variant="standard"
                            value={
                              TreatmentTextInputs[inputKey] ?? field.label ?? ""
                            }
                            onChange={(e) =>
                              handleTreatmentInputChange(
                                inputKey,
                                e.target.value
                              )
                            }
                          />
                        ) : (
                          field.label || "-"
                        )}
                      </StyledTableCell>
                    );
                  })}
                </StyledTableRow>
              );
            })}
            {data.length === 0 && (
              <StyledTableRow>
                <StyledTableCell
                  align="left"
                  colSpan={7}
                  sx={{ textAlign: "center" }}
                >
                  No Data Found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </StyledTable>
      </StyledTableContainer>
    </Box>
  );
};

const TreatmentPlanNonPharmacologicalTable = ({
  data,
  TreatmenteditMode,
  TreatmentTextInputs,
  handleTreatmentInputChange,
}: TreatmentPlanNonPharmacologicalTableProps) => {
  
  return (
    <Box style={{ width: "100%", overflowX: "auto" }}>
      <StyledTableContainer>
        <StyledTable style={{ tableLayout: "auto" }}>
          <TableHead>
            <TableRow key={"tableHead"}>
              <StyledTableCell align="left">ICD Code</StyledTableCell>
              <StyledTableCell align="left">Therapy</StyledTableCell>
              <StyledTableCell align="left">Support Measures</StyledTableCell>
              <StyledTableCell align="left">
                Substance Cessation
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, i) => {
              const fields = [
                { key: "code", label: item.code },
                { key: "psychotherapy", label: item.psychotherapy },
                { key: "supportive_measures", label: item.supportive_measures },
                { key: "substance_cessation", label: item.substance_cessation },
              ];

              return (
                <StyledTableRow key={i}>
                  {fields.map((field, idx) => {
                    const inputKey = `${field.key}_${i}`;
                    return (
                      <StyledTableCell align="left" key={idx}>
                        {TreatmenteditMode ? (
                          <TextField
                            fullWidth
                            variant="standard"
                            value={TreatmentTextInputs[inputKey] ?? field.label ?? ""}
                            onChange={(e) =>
                              handleTreatmentInputChange(inputKey, e.target.value)
                            }
                          />
                        ) : (
                          field.label || "-"
                        )}
                      </StyledTableCell>
                    );
                  })}
                </StyledTableRow>
              );
            })}
            {data.length === 0 && (
              <StyledTableRow>
                <StyledTableCell
                  align="left"
                  colSpan={4}
                  sx={{ textAlign: "center" }}
                >
                  No Data Found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </StyledTable>
      </StyledTableContainer>
    </Box>
  );
};



export {
  TreatmentPlanPharmacologicalTable,
  TreatmentPlanNonPharmacologicalTable,
};
